import React, { memo } from 'react';
import backgroundImage from '../../../assets/img/login/LoginPageBackground.jpg';
import styles from './Login.module.css';


const Login: React.FC = () => (
  <section className={styles.pageWrapper}>
    <img src={backgroundImage} className={styles.background} alt="" />
  </section>
);

export default memo(Login);
